import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import { Translate as $t } from "@/plugins/translate";
import SaleOption from "@/modules/settings/sale-option";

export default {
  namespaced: true,
  state: {
    success: false,
    message: null,
    count: 0,
    list: [],
    saleOption: null,
  },
  getters: {
    count: (state: any): Number => state.count,
    ResponseStatus: (state: any): any => ({
      success: state.success,
      message: state.message,
    }),
    list: (state: any): Array<any> => state.list,
    saleOption: (state: any): any => state.saleOption,
  },
  mutations: {
    SET_RESPONSE_STATUS(state: any, payload: any) {
      state.message = payload?.message || null;
      state.success = payload?.success || false;
    },
    SET_OPTIONS_LIST(state: any, payload: any) {
      state.list = payload.data;

      state.count = payload?.count || 0;
    },
    SET_OPTION(state: any, payload: any) {
      state.saleOption = payload;
    },
    SET_SALE_OPTION_RESULT(state: any, payload: any) {
      state.saleOption = payload.saleOption;
      state.success = payload.success;
      state.message = payload.message;
    },
  },
  actions: {
    async getSaleOptions({ commit }: { commit: any }, { locations = "", search = "", page = 1, itemsPerPage = 48 }) {
      return await request
        .get(`${ENDPOINTS.ORDER_OPTIONS}?page=${page}&page_size=${itemsPerPage}&search=${search}${locations}`)
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          const options = data.map((option) => new SaleOption(option));
          await commit("SET_OPTIONS_LIST", { data: options, count });
          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
        })
        .catch(async ({ error }) => {
          await commit("SET_OPTIONS_LIST", null);
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
          console.log(error);
        });
    },

    async getSaleOption({ commit }: { commit: any }, saleOptionId) {
      return await request
        .get(`${ENDPOINTS.ORDER_OPTIONS}/${saleOptionId}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_SALE_OPTION_RESULT", {
            saleOption: new SaleOption(data),
            success: true,
            message: data?.message || "",
          });
        })
        .catch(async ({ error }) => {
          await commit("SET_SALE_OPTION_RESULT", { saleOption: null, success: false, message: error.message || "" });

          console.log(error);
        });
    },

    async createSaleOption({ commit }: { commit: any }, SaleOption) {
      return await request
        .post(`${ENDPOINTS.ORDER_OPTIONS}`, SaleOption)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_SALE_OPTION_RESULT", {
              saleOption: data,
              success: true,
              message: data?.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_SALE_OPTION_RESULT", { saleOption: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },

    async updateSaleOption({ commit }: { commit: any }, saleOption) {
      return await request
        .put(`${ENDPOINTS.ORDER_OPTIONS}/${saleOption.id}`, saleOption.body)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_SALE_OPTION_RESULT", {
              saleOption: data,
              success: true,
              message: data?.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_SALE_OPTION_RESULT", { saleOption: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },

    async deleteSaleOption({ commit }: { commit: any }, saleOptionId) {
      return await request
        .delete(`${ENDPOINTS.ORDER_OPTIONS}/${saleOptionId}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_SALE_OPTION_RESULT", {
            saleOption: new SaleOption(data),
            success: true,
            message: data?.message || "",
          });
        })
        .catch(async ({ error }) => {
          await commit("SET_SALE_OPTION_RESULT", { saleOption: null, success: false, message: error.message || "" });

          console.log(error);
        });
    },
  },
};
